import React from 'react'
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { CardWrapper } from "../ui/CardWrapper";
import { Card } from "../ui/Card";
import { InfoCard } from "../ui/InfoCard";

interface IProps {
  hideInfo?: boolean;
}

export function DirectMerchantSubscriptions({ hideInfo }: IProps) {
  const { t } = useTranslation();
  return (
    <>
      <CardWrapper title={t("subscription.cardHeader")}>
        <Card />
      </CardWrapper>
      {hideInfo && < InfoCard
        title={t("subscription.merchant.infoCard.title") as string}
        content={<Trans
          i18nKey="subscription.merchant.infoCard.content"
          components={{ bold: <strong /> }}
        />}
      />
      }
    </>
  )
}
